import { useLingui } from "@lingui/react"
import { Trans } from "@lingui/react/macro"
import { Button } from "@mantine/core"
import { IconBrandTeams, IconClock, IconEye } from "@tabler/icons-react"
import { displayMeetingTitle } from "../../lib/meeting-title"
import { AvatarStack } from "../AvatarStack"
import { minutesSince } from "./helpers"
import type { IProps } from "./interfaces"

import classes from "./styles.module.css"

/**
 * MeetingHeroLive — the prominent "recording in progress" banner shown at the
 * top of the Lexicanon meeting list when a fresh in-progress meeting exists.
 * Pure presentational: takes the live meeting in, emits `onView` when the user
 * opts to open the recording.
 */
export const MeetingHeroLive = ({ meeting, onView }: IProps): React.JSX.Element => {
  const { i18n } = useLingui()
  const elapsed = minutesSince(meeting.start_time)
  const speakers = meeting.speaker_names ?? []
  return (
    <div className={classes.hero} data-testid="meeting-hero-live">
      <div className={classes.heroBody}>
        <span className={classes.heroEye}>
          <span className={classes.wave}>
            <span /> <span /> <span /> <span /> <span />
          </span>
          <Trans>Recording in progress</Trans>
        </span>
        <h2 className={classes.heroTitle}>{displayMeetingTitle(meeting.subject, meeting.topics, i18n)}</h2>
        <div className={classes.heroSub}>
          <IconClock size={13} />
          <span>
            <Trans>
              Started {elapsed} min ago · {speakers.length} speakers
            </Trans>
          </span>
          {meeting.source === "teams" && (
            <>
              <span className="lex-dot" />
              <IconBrandTeams size={13} />
              <span>Microsoft Teams</span>
            </>
          )}
          {speakers.length > 0 && (
            <>
              <span className="lex-dot" />
              <AvatarStack names={speakers} />
            </>
          )}
        </div>
      </div>
      <div className={classes.heroActions}>
        <Button leftSection={<IconEye size={14} />} onClick={onView}>
          <Trans>Open recording</Trans>
        </Button>
      </div>
    </div>
  )
}
